/** Synchronous handoff from a dialog's capture-phase Escape hook to its focused composer. */
export const ASSISTANT_SUGGESTION_ESCAPE_EVENT = 'assistant-suggestion-escape';

/** Give visible suggestions the first Escape before the viewer closes or leaves full screen. */
export function consumeAssistantSuggestionEscape(
  event: KeyboardEvent,
): boolean {
  if (event.defaultPrevented) return true;
  if (event.isComposing || !(event.target instanceof EventTarget)) return false;
  const consumed = !event.target.dispatchEvent(
    new Event(ASSISTANT_SUGGESTION_ESCAPE_EVENT, {
      bubbles: true,
      cancelable: true,
    }),
  );
  if (consumed) event.preventDefault();
  return consumed;
}
